module.exports = __webpack_public_path__ + "assets/img/btn-detail-aeb5b32c.png";